import React from 'react';

import HelmetHelper from '../../components/HelmetHelper';
import conversionTracker from '../../utils/conversionTracker';
import NanoMajorSlider from '../../components/NanoMajorSlider';
import nextStartDate from '../../utils/nextStartDate';
import NextStartDate from '../../components/NextStartDate';
import StorySlider from '../../components/StorySlider';
import { safeCredentials, handleErrors } from '../../utils/fetchHelpers';

class Stats extends React.Component {
  state = {
    rt_in_less_than_15_minutes: 0,
    rt_in_less_than_30_minutes: 0,
    rt_in_less_than_60_minutes: 0,
    rt_in_less_than_12_hours: 0,
    stats: {
      total_students: 10000,
    },
    user_locations: [],
  };

  componentDidMount() {
    conversionTracker(window, 'ViewContent', {
      content_category: 'information',
      content_name: 'stats',
    });

    fetch('/api/v2/stats', safeCredentials())
      .then(handleErrors)
      .then(stats => {
        this.setState({ stats });
      });

    fetch('/api/v2/profiles_index_locations', safeCredentials())
      .then(handleErrors)
      .then(user_locations => {
        this.setState({ user_locations: user_locations.data });
      })

    fetch('/api/v2/questions_response_time_stats', safeCredentials())
      .then(handleErrors)
      .then(response => {
        this.setState({
          rt_in_less_than_15_minutes: Math.round(response.stats.num_15_mins_or_less * 100),
          rt_in_less_than_30_minutes: Math.round(response.stats.num_30_mins_or_less * 100),
          rt_in_less_than_60_minutes: Math.round(response.stats.num_60_mins_or_less * 100),
          rt_in_less_than_12_hours: Math.round(response.stats.num_12_hours_or_less * 100),
        });
      });
  }

  render() {
    const { stats, user_locations } = this.state;
    const { server_data } = this.props;
    const { tracks } = server_data;

    return (
      <div>
        <HelmetHelper
          title="Stats"
          description="Real time stats of Altcademy"
          url="https://www.altcademy.com/stats"
        />

        <div className="bg-white">
          <div className="container">
            <div className="row content valueProps">
              <div className="col-12 valueProp">
                <div>
                  <h1 className="mb-3 serif text-center">Real-time Stats</h1>
                  <p className="text-left text-sm-center mx-auto mw-700 explanation">See our real-time stats in our learning platform</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row content valueProps">
            <div className="col-12 valueProp">
              <div className="row">
                <div className="col-12">
                  <div className="text-center">
                    <p className="explanation mb-5" style={{fontWeight: '400'}}>Our Students</p>
                  </div>
                </div>
                <div className="col-12 mx-auto">
                  <div className="text-center">
                    <p className="explanation altColor"><b>{stats.total_students || '9,000'} forward-thinking learners</b></p>
                    <p className="explanation">comes from {user_locations.length || 95} cities and counting</p>
                    <p className="explanation altColor">66% are currently employed</p>
                    <p className="explanation">6% are in school</p>
                    <p className="explanation">2% are self-employed</p>
                    <p className="explanation altColor">40% are beginners</p>
                    <p className="explanation altColor">40% are elementary learners</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white" style={{overflow: 'hidden'}}>
          <div className="container">
            <div className="row content valueProps">
              <div className="col-12 valueProp">
                <div className="row">
                  <div className="col-12">
                    <div className="text-center">
                      <p className="explanation mb-5" style={{fontWeight: '400'}}>Q&A Stats</p>
                    </div>
                  </div>
                  <div className="col-12 mx-auto">
                    <div className="text-center">
                      <p className="explanation">{this.state.rt_in_less_than_15_minutes || 20}% questions are answered in less than 15 minutes</p>
                      <p className="explanation">{this.state.rt_in_less_than_30_minutes >= 35 ? this.state.rt_in_less_than_30_minutes : 35}% questions are answered in less than 30 minutes</p>
                      <p className="explanation altColor"><b>{this.state.rt_in_less_than_60_minutes >= 60 ? this.state.rt_in_less_than_60_minutes : 60}% questions are answered in less than 60 minutes</b></p>
                      <p className="explanation">99+% questions are answered in less than 12 hours</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row content valueProps">
            <div className="col-12 valueProp">
              <div className="row">
                <div className="col-12">
                  <div className="text-center">
                    <p className="explanation mb-5" style={{fontWeight: '400'}}>Teaching Stats</p>
                  </div>
                </div>
                <div className="col-12 mx-auto">
                  <div className="text-center">
                    <p className="explanation">{stats.total_documents || '1,000'} teaching materials created</p>
                    <p className="explanation altColor"><b>{stats.total_document_changes || '2,500'} revisions made to curriculum</b></p>
                    <p className="explanation">{stats.total_accomplishments || '8,500'} student accomplishments in curriculum</p>
                    <p className="explanation">{stats.total_assignments || '30,000'} assignments created</p>
                    <p className="explanation">{stats.total_questions || '400'} questions asked</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white" style={{overflow: 'hidden'}}>
          <div className="container">
            <div className="row content valueProps">
              <div className="col-12 valueProp">
                <div className="row">
                  <div className="col-12">
                    <div className="text-center">
                      <p className="explanation mb-5" style={{fontWeight: '400'}}>Why do our students want to learn?</p>
                    </div>
                  </div>
                  <div className="col-12 mx-auto">
                    <div className="text-center">
                      <p className="explanation mw-500 mx-auto">"Change my career."</p>
                      <p className="explanation mw-500 mx-auto">"I have always been curious how a website is made but never really had the time to learn it. Now that I have the time, I am using it to learn about it and potentially change my career."</p>
                      <p className="explanation mw-500 mx-auto">"I'm looking to gain a new skill. I hope learning to code will help me understand what is possible and discover new ways to be effective in my industry."</p>
                      <p className="explanation mw-500 mx-auto">"I hope to gain job-ready skills that will allow me to pursue new and exciting endeavors. I already have some web development skills, and I plan on expanding those immensely."</p>
                      <p className="explanation mw-500 mx-auto">"Create professional grade websites."</p>
                      <p className="explanation mw-500 mx-auto">"Learn how to build and maintain a website."</p>
                      <p className="explanation mw-500 mx-auto">"Being able to lead my team to develop better products in a more organized manner."</p>
                      <p className="explanation mw-500 mx-auto">"Being able to tell and design great products."</p>
                      <p className="explanation mw-500 mx-auto">"Being able to better launch products and keep improving."</p>
                      <p className="explanation mw-500 mx-auto">"To be able to develop websites both for personal hobbies and for business ventures."</p>
                      <p className="explanation mw-500 mx-auto">"Learn a new skill."</p>
                      <p className="explanation mw-500 mx-auto">"I'd like to be able to build responsive web pages."</p>
                      <p className="explanation mw-500 mx-auto">"I am trying to switch careers. I live in a city that is a big tech hub, and I would like to get a job in the tech field."</p>
                      <p className="explanation mw-500 mx-auto">"My goal is to become a proficient full-stack application developer."</p>
                      <p className="explanation mw-500 mx-auto">"I want to become a full-stack developer. Thus, I need to understand and be able to code on the back-end as well as front-end."</p>
                      <p className="explanation mw-500 mx-auto">"I've always dreamed of being a successful IT entrepreneur."</p>
                      <p className="explanation mw-500 mx-auto">"I would really like a second income that would allow me to work remotely."</p>
                      <p className="explanation mw-500 mx-auto">"I want to get good knowledge of pure JavaScript."</p>
                      <p className="explanation mw-500 mx-auto">"I'm looking for a career change. I feel like programming is something I can learn from home at a relatively low cost."</p>
                      <p className="explanation mw-500 mx-auto">"To get a job related to programming/coding."</p>
                      <p className="explanation mw-500 mx-auto">"Polish my JavaScript skills"</p>
                      <p className="explanation mw-500 mx-auto">"Update my knowledge to catch up with market standards. Be able to build a website using the tools, software and work process currently being used in the industry."</p>
                      <p className="explanation mw-500 mx-auto">"Improve my knowledge and skill with front-end technology."</p>
                      <p className="explanation mw-500 mx-auto">"As a graphic designer, I am interested in achieving the skills to build not only beautiful but also responsive and functional websites."</p>
                      <p className="explanation mw-500 mx-auto">"To future-proof myself."</p>
                      <p className="explanation mw-500 mx-auto">"Build stuff that are useful and fun."</p>
                      <p className="explanation mw-500 mx-auto">"To satisfy my curiosity."</p>
                      <p className="explanation mw-500 mx-auto">"To learn, understand coding and become a software engineer."</p>
                      <p className="explanation mw-500 mx-auto">"To be a competent full-stack web developer."</p>
                      <p className="explanation mw-500 mx-auto">"I've always wished to develop applications professionally."</p>
                      <p className="explanation mw-500 mx-auto">"I've always been interested in programming but don't have a CS degree."</p>
                      <p className="explanation mw-500 mx-auto">"To learn programming."</p>
                      <p className="explanation mw-500 mx-auto">"I want to be able to create websites and games."</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row content valueProps">
            <div className="col-12 valueProp">
              <div className="row">
                <div className="col-12">
                  <div className="text-center">
                    <p className="explanation mb-5" style={{fontWeight: '400'}}>Where do our students come from?</p>
                  </div>
                </div>
                <div className="col-12 mx-auto">
                  <div className="text-center">
                    <p className="explanation mw-500 mx-auto">Information Technology, Jewelry, Education, Food and Beverage, Finance Technology, Finance, Health Insurance, Healthcare IT, Graphics Design, Media, Marketing, Engineering, Accounting, Design, Journalism</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white">
          <div className="container">
            <div className="row content valueProps">
              <div className="col-12 valueProp">
                <div className="row">
                  <div className="col-12">
                    <div className="text-center">
                      <h2>Ready To Begin?</h2>
                      <p className="explanation mw-500 mx-auto">Pick a program and join Cohort #{new nextStartDate().cohortNumber()}, starting <NextStartDate />.</p>
                    </div>
                  </div>
                  <div className="col-12 pt-3 pb-3">
                    <NanoMajorSlider nanomajors={['fsdsai', 'fswd', 'fewd']} tracks={tracks} />
                  </div>
                </div>
              </div>

              <div className="col-12 valueProp">
                <div className="row">
                  <div className="col-12">
                    <div className="text-center">
                      <h2>By the way</h2>
                      <p className="explanation mw-500 mx-auto">Read a story from one of our students on why they are learning programming.</p>
                    </div>
                  </div>
                  <div className="col-12 col-lg-9 mx-lg-auto">
                    <StorySlider />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Stats;
